import React, { Fragment, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import icon from '../../images/icon/magic.svg';
import gImg1 from '../../images/php.png';
import gImg2 from '../../images/dotnet.png';
import gImg3 from '../../images/postgre.png';
import gImg4 from '../../images/react.png';
import gImg5 from '../../images/docker.png';
import gImg6 from '../../images/js.png';
import Seo from '../../components/Seo';

const ServicesPage = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();

    // Set language based on URL parameter
    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'ka')) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return (
        <Fragment>
            <Seo 
                title={t('seo.services.title')}
                description={t('seo.services.description')}
                keywords={t('seo.services.keywords')}
                url={`/${lang}/services`}
            />
            <Layout>

                {/* Hero Section with Animation */}
                <motion.section
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="page-title cp-page-title pos-rel"
                >
                    <div className="container">
                        <div className="page-title-wrap">
                            <div className="row mt-none-30 align-items-center">
                                <div className="col-lg-8 pt-140" id="ServiceTitleHolder">
                                    <motion.div 
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: 0.3 }}
                                        className="page-title-box pt-30"
                                    >
                                        <motion.span 
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.5 }}
                                            className="sub-title"
                                        >
                                            <img src={icon} alt="" /> {t('services.title')}
                                        </motion.span>
                                        <motion.h2 
                                            initial={{ opacity: 0, y: 30 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ delay: 0.7 }}
                                            className="title"
                                        >
                                            {t('services.subtitle')}
                                        </motion.h2>
                                    </motion.div>
                                </div>
                                <div className="col-lg-4 overflow-hidden align-items-center justify-content-center d-flex">
                                    <motion.div 
                                        initial={{ opacity: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{ delay: 0.9, duration: 0.5 }}
                                        className="cp-img-slide"
                                    >
                                        <div className="cp-img-inner ul_li">
                                            <div className="cp-item marquee-first">
                                                <div className="xb-img"><img src={gImg1} alt="PHP" /></div>
                                                <div className="xb-img"><img src={gImg2} alt=".NET" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="PostgreSQL" /></div>
                                                <div className="xb-img"><img src={gImg1} alt="PHP" /></div>
                                                <div className="xb-img"><img src={gImg2} alt=".NET" /></div>
                                                <div className="xb-img"><img src={gImg3} alt="PostgreSQL" /></div>
                                            </div>
                                            <div className="cp-item marquee-2">
                                                <div className="xb-img"><img src={gImg4} alt="React" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="Docker" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="JavaScript" /></div>
                                                <div className="xb-img"><img src={gImg4} alt="React" /></div>
                                                <div className="xb-img"><img src={gImg5} alt="Docker" /></div>
                                                <div className="xb-img"><img src={gImg6} alt="JavaScript" /></div>
                                            </div>
                                        </div>
                                    </motion.div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.section>

                {/* Services Section with Animation */}
                <motion.section 
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5, duration: 0.8 }}
                    className="terms&conditions-section pb-85 cp-det-bg"
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <motion.div 
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.7, duration: 0.6 }}
                                    className="item-details-widget" 
                                        style={{ padding: '50px 50px 60px 50px' }}
                                >
                                    <motion.div 
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 0.9 }}
                                        className="service-item mb-50"
                                    >
                                        <h3 className="mb-20">⚡ {t('services.webDevelopment')}</h3>
                                        <p>
                                            {t('services.webDevelopmentContent')}
                                        </p>
                                        <Link 
                                            to={`/${lang}/services/web-development`} 
                                            className="orbx-btn mt-3"
                                            aria-label={`${t('common.learnMore')} - ${t('services.webDevelopment')}`}
                                            title={`${t('common.learnMore')} - ${t('services.webDevelopment')}`}
                                        >
                                            {t('common.learnMore')} <i className="fas fa-arrow-right"></i>
                                        </Link>
                                    </motion.div>

                                    <motion.div 
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 1.0 }}
                                        className="service-item mb-50"
                                    >
                                        <h3 className="mb-20">📱 {t('services.mobileApps')}</h3>
                                        <p>
                                            {t('services.mobileAppsContent')}
                                        </p>
                                        <Link 
                                            to={`/${lang}/services/mobile-apps`} 
                                            className="orbx-btn mt-3"
                                            aria-label={`${t('common.learnMore')} - ${t('services.mobileApps')}`}
                                            title={`${t('common.learnMore')} - ${t('services.mobileApps')}`}
                                        >
                                            {t('common.learnMore')} <i className="fas fa-arrow-right"></i>
                                        </Link>
                                    </motion.div>

                                    <motion.div 
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 1.1 }}
                                        className="service-item mb-50"
                                    >
                                        <h3 className="mb-20">🛡️ {t('services.infrastructure')}</h3>
                                        <p>
                                            {t('services.infrastructureContent')}
                                        </p>
                                        <Link 
                                            to={`/${lang}/services/infrastructure`} 
                                            className="orbx-btn mt-3"
                                            aria-label={`${t('common.learnMore')} - ${t('services.infrastructure')}`}
                                            title={`${t('common.learnMore')} - ${t('services.infrastructure')}`}
                                        >
                                            {t('common.learnMore')} <i className="fas fa-arrow-right"></i>
                                        </Link>
                                    </motion.div>

                                    <motion.div 
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: 1.2 }}
                                        className="service-item"
                                    >
                                        <h3 className="mb-20">🚀 {t('services.partnership')}</h3>
                                        <p>
                                            {t('services.partnershipContent')}
                                        </p>
                                        <Link 
                                            to={`/${lang}/services/partnership`} 
                                            className="orbx-btn mt-3"
                                            aria-label={`${t('common.learnMore')} - ${t('services.partnership')}`}
                                            title={`${t('common.learnMore')} - ${t('services.partnership')}`}
                                        >
                                            {t('common.learnMore')} <i className="fas fa-arrow-right"></i>
                                        </Link>
                                    </motion.div>
                                </motion.div>
                            </div>
                        </div>
                    </div>
                </motion.section>
            </Layout>
        </Fragment>
    );
};

export default ServicesPage;